import type { ChatDetailsButtonProps } from './ChatDetailsButton.types';
import * as React from 'react';

import { IconButton } from '../shared/IconButton';

export const ChatDetailsButton: React.FC<ChatDetailsButtonProps> = ({
  isGroupChat = false,
  onClick,
  popupPosition,
  size,
  testid,
  compact,
}) => (
  <IconButton
    content={isGroupChat ? 'View Group Details' : 'View Conversation Details'}
    icon="info"
    testid={`${testid}-buttonChatDetails`}
    {...{ onClick, popupPosition, size, compact }}
  />
);
